// Workflow steps for each main transaction type
// Each step maps to a sub_type in the transactions system

export const WORKFLOW_STEPS = {
  new_residence: {
    ar: 'إقامة جديدة',
    en: 'New Residence',
    steps: [
      { sub_type: 'زيارة أولى', ar: 'زيارة أولى', en: 'First Visit' },
      { sub_type: 'دبي للتأمين', ar: 'دبي للتأمين', en: 'Dubai Insurance' },
      { sub_type: 'مصاريف العمل', ar: 'مصاريف العمل', en: 'Labor Payment' },
      { sub_type: 'إصدار تأشيرة داخل الدولة', ar: 'إصدار تأشيرة داخل الدولة', en: 'New Visa Inside Country' },
      { sub_type: 'تعديل وضع', ar: 'تعديل وضع', en: 'Change Status' },
      { sub_type: 'توجيه', ar: 'توجيه', en: 'TAW-JEEH' },
      { sub_type: 'فحص طبي', ar: 'فحص طبي', en: 'Medical Exam' },
      { sub_type: 'هوية', ar: 'هوية', en: 'Emirates ID' },
      { sub_type: 'الإقامة', ar: 'الإقامة', en: 'Visa Stamp' },
      { sub_type: 'التعطل عن العمل', ar: 'التعطل عن العمل', en: 'ILOE Insurance', optional: true },
      { sub_type: 'غرامة التعطل عن العمل', ar: 'غرامة التعطل عن العمل', en: 'ILOE Insurance Fine', optional: true },
      { sub_type: 'مخالفات الجوازات', ar: 'مخالفات الجوازات', en: 'Immigration Violations', optional: true },
      { sub_type: 'مخالفات العمل', ar: 'مخالفات العمل', en: 'Labor Violations', optional: true },
      { sub_type: 'مخالفات الهوية', ar: 'مخالفات الهوية', en: 'ID FINE', optional: true },
      { sub_type: 'طلب استرحام', ar: 'طلب استرحام', en: 'Clemency Request', optional: true },
      { sub_type: 'تعديل عقد العمل', ar: 'تعديل عقد العمل', en: 'Modify Contract', optional: true },
      { sub_type: 'اضافة / تعديل رقم الهاتف في سيستم الهجره', ar: 'اضافة / تعديل رقم الهاتف في سيستم الهجره', en: 'Add/change ICP Mobile Number', optional: true },
      { sub_type: 'تحديث بيانات الجواز في سيستم العمل', ar: 'تحديث بيانات الجواز في سيستم العمل', en: 'Update Passport Data in MOHRE System', optional: true },
      { sub_type: 'طلب اعادة النظر', ar: 'طلب اعادة النظر', en: 'Reconsideration Request', optional: true },
    ]
  },
  renewal: {
    ar: 'تجديد إقامة',
    en: 'Renewal',
    steps: [
      { sub_type: 'تجديد عقد العمل', ar: 'تجديد عقد العمل', en: 'Renew Labor Contract' },
      { sub_type: 'دبي للتأمين', ar: 'دبي للتأمين', en: 'Dubai Insurance' },
      { sub_type: 'مصاريف العمل', ar: 'مصاريف العمل', en: 'Labor Payment' },
      { sub_type: 'توجيه', ar: 'توجيه', en: 'TAW-JEEH' },
      { sub_type: 'فحص طبي', ar: 'فحص طبي', en: 'Medical Exam' },
      { sub_type: 'تجديد الهوية', ar: 'تجديد الهوية', en: 'Renew Emirates ID' },
      { sub_type: 'الإقامة', ar: 'الإقامة', en: 'Visa Stamp' },
      { sub_type: 'مخالفات العمل', ar: 'مخالفات العمل', en: 'Labor Violations', optional: true },
      { sub_type: 'التعطل عن العمل', ar: 'التعطل عن العمل', en: 'ILOE Insurance', optional: true },
      { sub_type: 'غرامة التعطل عن العمل', ar: 'غرامة التعطل عن العمل', en: 'ILOE Insurance Fine', optional: true },
      { sub_type: 'مخالفات الجوازات', ar: 'مخالفات الجوازات', en: 'Immigration Violations', optional: true },
      { sub_type: 'مخالفات الهوية', ar: 'مخالفات الهوية', en: 'ID FINE', optional: true },
      { sub_type: 'تعديل عقد العمل', ar: 'تعديل عقد العمل', en: 'Modify Contract', optional: true },
      { sub_type: 'اضافة / تعديل رقم الهاتف في سيستم الهجره', ar: 'اضافة / تعديل رقم الهاتف في سيستم الهجره', en: 'Add/change ICP Mobile Number', optional: true },
      { sub_type: 'تحديث بيانات الجواز في سيستم العمل', ar: 'تحديث بيانات الجواز في سيستم العمل', en: 'Update Passport Data in MOHRE System', optional: true },
      { sub_type: 'طلب اعادة النظر', ar: 'طلب اعادة النظر', en: 'Reconsideration Request', optional: true },
    ]
  },
  temp_work_permit: {
    ar: 'تصريح عمل مؤقت',
    en: 'TM Work Permit',
    steps: [
      { sub_type: 'تصريح عمل مؤقت 6 أشهر', ar: 'تصريح عمل مؤقت 6 أشهر', en: 'TM 6 Months' },
      { sub_type: 'دبي للتأمين', ar: 'دبي للتأمين', en: 'Dubai Insurance', optional: true },
      { sub_type: 'تسليم تصريح 6 أشهر', ar: 'تسليم تصريح 6 أشهر', en: 'Submit TM 6 Months' },
      { sub_type: 'تحديث بيانات الجواز في سيستم العمل', ar: 'تحديث بيانات الجواز في سيستم العمل', en: 'Update Passport Data in MOHRE System', optional: true },
    ]
  },
  partial_work: {
    ar: 'تصريح عمل بعض الوقت',
    en: 'Partial Work',
    steps: [
      { sub_type: 'تصريح عمل بعض الوقت', ar: 'تصريح عمل بعض الوقت', en: 'TP Work Permit' },
      { sub_type: 'دبي للتأمين', ar: 'دبي للتأمين', en: 'Dubai Insurance', optional: true },
      { sub_type: 'تسليم تصريح عمل لبعض الوقت', ar: 'تسليم تصريح عمل لبعض الوقت', en: 'Submit TP Work Permit' },
      { sub_type: 'تحديث بيانات الجواز في سيستم العمل', ar: 'تحديث بيانات الجواز في سيستم العمل', en: 'Update Passport Data in MOHRE System', optional: true },
    ]
  },
  gcc_work_permit: {
    ar: 'تصريح عمل مواطن',
    en: 'GCC Work Permit',
    steps: [
      { sub_type: 'عقد عمل مواطن', ar: 'عقد عمل مواطن', en: 'LOCAL CONTRACT' },
      { sub_type: 'دبي للتأمين', ar: 'دبي للتأمين', en: 'DIC INSURANCE' },
      { sub_type: 'تسليم تصريح عمل مواطن', ar: 'تسليم تصريح عمل مواطن', en: 'SUBMIT LOCAL CONTRACT' },
      { sub_type: 'تحديث بيانات الجواز في سيستم العمل', ar: 'تحديث بيانات الجواز في سيستم العمل', en: 'Update Passport Data in MOHRE System', optional: true },
    ]
  },
  cancellation: {
    ar: 'إلغاء',
    en: 'Cancellation',
    steps: [
      { sub_type: 'إلغاء ملف العمل', ar: 'إلغاء ملف العمل', en: 'Cancel Labor File' },
      { sub_type: 'إلغاء الجوازات', ar: 'إلغاء الجوازات', en: 'Cancel Immigration' },
      { sub_type: 'تحديث بيانات الجواز في سيستم العمل', ar: 'تحديث بيانات الجواز في سيستم العمل', en: 'Update Passport Data in MOHRE System', optional: true },
    ]
  },
  cancellation_temp_6m: {
    ar: 'إلغاء تصريح عمل مؤقت 6 أشهر',
    en: 'TM MOHRE Cancellation 6 Months',
    steps: [
      { sub_type: 'إلغاء تصريح عمل مؤقت 6 أشهر', ar: 'إلغاء تصريح عمل مؤقت 6 أشهر', en: 'TM MOHRE Cancellation 6 Months' },
      { sub_type: 'تحديث بيانات الجواز في سيستم العمل', ar: 'تحديث بيانات الجواز في سيستم العمل', en: 'Update Passport Data in MOHRE System', optional: true },
    ]
  },
  new_residence_outside: {
    ar: 'إقامة عامل خارج الدولة',
    en: 'New Residence - Outside Country',
    steps: [
      { sub_type: 'زيارة أولى', ar: 'زيارة أولى', en: 'First Visit' },
      { sub_type: 'دبي للتأمين', ar: 'دبي للتأمين', en: 'Dubai Insurance' },
      { sub_type: 'مصاريف العمل', ar: 'مصاريف العمل', en: 'Labor Payment' },
      { sub_type: 'إصدار تأشيرة خارج الدولة', ar: 'إصدار تأشيرة خارج الدولة', en: 'New Visa Outside Country' },
      { sub_type: 'توجيه', ar: 'توجيه', en: 'TAW-JEEH' },
      { sub_type: 'فحص طبي', ar: 'فحص طبي', en: 'Medical Exam' },
      { sub_type: 'هوية', ar: 'هوية', en: 'Emirates ID' },
      { sub_type: 'الإقامة', ar: 'الإقامة', en: 'Visa Stamp' },
      { sub_type: 'التعطل عن العمل', ar: 'التعطل عن العمل', en: 'ILOE Insurance', optional: true },
      { sub_type: 'غرامة التعطل عن العمل', ar: 'غرامة التعطل عن العمل', en: 'ILOE Insurance Fine', optional: true },
      { sub_type: 'مخالفات الجوازات', ar: 'مخالفات الجوازات', en: 'Immigration Violations', optional: true },
      { sub_type: 'مخالفات العمل', ar: 'مخالفات العمل', en: 'Labor Violations', optional: true },
      { sub_type: 'طلب استرحام', ar: 'طلب استرحام', en: 'Clemency Request', optional: true },
      { sub_type: 'تعديل عقد العمل', ar: 'تعديل عقد العمل', en: 'Modify Contract', optional: true },
      { sub_type: 'اضافة / تعديل رقم الهاتف في سيستم الهجره', ar: 'اضافة / تعديل رقم الهاتف في سيستم الهجره', en: 'Add/change ICP Mobile Number', optional: true },
      { sub_type: 'تحديث بيانات الجواز في سيستم العمل', ar: 'تحديث بيانات الجواز في سيستم العمل', en: 'Update Passport Data in MOHRE System', optional: true },
    ]
  },
  cancellation_abroad: {
    ar: 'إلغاء عامل خارج الدولة',
    en: 'Outside Worker Cancellation',
    steps: [
      { sub_type: 'الغاء عامل خارج الدوله عمل', ar: 'إلغاء عامل خارج الدولة - عمل', en: 'Outside Worker Cancellation - Labor' },
      { sub_type: 'الغاء عامل خارج الدوله جوازات', ar: 'إلغاء عامل خارج الدولة - جوازات', en: 'Outside Worker Cancellation - Immigration' },
      { sub_type: 'طباعه كشف بيان حركة', ar: 'طباعه كشف بيان حركة', en: 'TRAVILE REPORT' },
      { sub_type: 'تحديث بيانات الجواز في سيستم العمل', ar: 'تحديث بيانات الجواز في سيستم العمل', en: 'Update Passport Data in MOHRE System', optional: true },
    ]
  },
  cancellation_temp_2y: {
    ar: 'إلغاء تصريح عمل مؤقت عامين',
    en: 'TM 2 Years Cancellation',
    steps: [
      { sub_type: 'إلغاء تصريح عمل مؤقت عامين', ar: 'إلغاء تصريح عمل مؤقت عامين', en: 'TM 2 Years Cancellation' },
      { sub_type: 'تحديث بيانات الجواز في سيستم العمل', ar: 'تحديث بيانات الجواز في سيستم العمل', en: 'Update Passport Data in MOHRE System', optional: true },
    ]
  },
  establishment_transactions: {
    ar: 'معاملات المنشأة',
    en: 'Establishment Transactions',
    company: true,
    steps: [
      { sub_type: 'فتح ملف العمل', ar: 'فتح ملف العمل', en: 'Open Labor File' },
      { sub_type: 'فتح ملف الهجرة', ar: 'فتح ملف الهجرة', en: 'Open Immigration File' },
      { sub_type: 'كوتة', ar: 'كوتة', en: 'Quota' },
      { sub_type: 'التصريح السنوي للأنشطة السياحية', ar: 'التصريح السنوي للأنشطة السياحية', en: 'Annual Tourism Activities Permit' },
      { sub_type: 'فتح يوزر في سيستم الهجرة', ar: 'فتح يوزر في سيستم الهجرة', en: 'Open User in Immigration System' },
      { sub_type: 'تحديث ملف العمل', ar: 'تحديث ملف العمل', en: 'Update Labor File' },
      { sub_type: 'تجديد بطاقة المنشأة', ar: 'تجديد بطاقة المنشأة', en: 'Renew Establishment Card' },
      { sub_type: 'تجديد التصريح السنوي للأنشطة السياحية', ar: 'تجديد التصريح السنوي للأنشطة السياحية', en: 'Renew Annual Tourism Activities Permit' },
      { sub_type: 'تصريح المغني شهر/شهرين/ثلاثة أشهر', ar: 'تصريح المغني شهر/شهرين/ثلاثة أشهر', en: 'Singer Permit 1/2/3 Months' },
    ]
  }
};
const normalizeAr = (text) => {
  if (!text) return '';
  return text
    .replace(/[إأآا]/g, 'ا')
    .replace(/[ؤ]/g, 'و')
    .replace(/[ئ]/g, 'ي')
    .replace(/ة/g, 'ه')
    .trim();
};

// Find which workflow key best matches a sub_type (handles Arabic text variations)
const findMatchingWorkflow = (subType) => {
  const norm = normalizeAr(subType);
  for (const [key, wf] of Object.entries(WORKFLOW_STEPS)) {
    if (wf.steps.some(s => normalizeAr(s.sub_type) === norm)) {
      return key;
    }
  }
  return null;
};

// Match transaction sub_type to a workflow step (handles Arabic text variations)
const matchStep = (stepSubType, txSubType) => {
  return normalizeAr(stepSubType) === normalizeAr(txSubType);
};

// Compute tracking status for an employee's transactions
export const computeWorkflowTracking = (transactions) => {
  if (!transactions || transactions.length === 0) return [];

  // For each transaction, find the best matching workflow key
  const assigned = {}; // workflowKey -> [transactions]
  const usedTxIds = new Set();

  // First pass: find the best workflow for each transaction
  transactions.forEach(tx => {
    const mt = tx.main_type;
    if (!mt) return;

    // Try exact main_type match first
    if (WORKFLOW_STEPS[mt]) {
      // But for "cancellation" main_type, check if a more specific workflow matches
      if (mt === 'cancellation') {
        const specificKey = findMatchingWorkflow(tx.sub_type);
        if (specificKey && specificKey !== 'cancellation') {
          if (!assigned[specificKey]) assigned[specificKey] = [];
          assigned[specificKey].push(tx);
          usedTxIds.add(tx.id);
          return;
        }
      }
      if (!assigned[mt]) assigned[mt] = [];
      assigned[mt].push(tx);
      usedTxIds.add(tx.id);
    } else {
      // Try to find by sub_type across all workflows
      const matchedKey = findMatchingWorkflow(tx.sub_type);
      if (matchedKey) {
        if (!assigned[matchedKey]) assigned[matchedKey] = [];
        assigned[matchedKey].push(tx);
        usedTxIds.add(tx.id);
      }
    }
  });

  const workflows = [];

  for (const [wfKey, txs] of Object.entries(assigned)) {
    const wf = WORKFLOW_STEPS[wfKey];
    if (!wf) continue;

    // Build a map of normalized sub_type -> transaction
    const txMap = {};
    txs.forEach(tx => { txMap[normalizeAr(tx.sub_type)] = tx; });

    let lastCompletedIdx = -1;
    let hasPending = false;

    // Build steps: include optional steps ONLY if they have a matching transaction
    const steps = [];
    wf.steps.forEach((step, idx) => {
      const tx = txMap[normalizeAr(step.sub_type)];
      // Skip optional steps that have no transaction
      if (step.optional && !tx) return;
      
      let status = 'upcoming';
      if (tx) {
        if (tx.status === 'completed') {
          status = 'completed';
          lastCompletedIdx = steps.length;
        } else if (tx.status === 'waiting_approval') {
          status = 'waiting_approval';
          hasPending = true;
        } else if (tx.status === 'pending') {
          status = 'in_progress';
          hasPending = true;
        } else if (tx.status === 'cancelled') {
          status = 'cancelled';
        }
      }
      steps.push({ ...step, status, transaction: tx || null });
    });

    // Calculate completion: workflow is "done" if all required steps are completed OR cancelled (no upcoming/in_progress)
    const requiredSteps = steps.filter(s => !s.optional);
    const allCompleted = requiredSteps.length > 0 && requiredSteps.every(s => s.status === 'completed' || s.status === 'cancelled');
    const progress = steps.filter(s => s.status === 'completed').length;

    workflows.push({
      mainType: wfKey,
      label: wf,
      steps,
      progress,
      total: steps.length,
      allCompleted,
      transactions: txs
    });
  }

  return workflows;
};
